import React, { useEffect, useState } from "react";
import "./styles.css";
import ApexCharts from "apexcharts";
import ReactApexChart from "react-apexcharts";
import {
  growthTrackingGraphApi,
  growthTrackingListApi,
} from "services/growthTracking";
import useFullPageLoader from "common/UseFullPageLoader";
import { formatToDDMMYYYY } from "utils/dateFormat";
import Accordion from "react-bootstrap/Accordion";
import { firstWordCapital, formatRelativeDate } from "utils/common";
import moment from "moment";

const Measurement = ({ _child, type }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [measurement, setMeasurement] = useState([]);
  const [graphDetail, setGraphDetail] = useState({});
  const [duration, setDuration] = useState("DAY");

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await growthTrackingListApi({
        childId: _child,
        duration,
        type,
        limit: 5000,
      });
      const graph = await growthTrackingGraphApi({ childId: _child, type });
      if (status === 200) {
        setMeasurement(data?.data);
        setGraphDetail(graph?.data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, [duration]);

  const chartData = {
    series: [
      {
        name: "Average",
        data: graphDetail?.graph?.map((ele) => Number(ele?.value).toFixed(2)),
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        // text: 'Product Trends by Month',
        align: "left",
      },
      grid: {
        row: {
          colors: ["#fff", "#fff"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: graphDetail?.graph?.map((ele) => `${ele?._id} Week`),
      },
    },
  };

  return (
    <>
      {loader}
      <div className="width_wrap">
        <div className="width_parents">
          <div className="width_lft_side">
            <div className="lft_cards">
              <div className="at_birth">
                <p>At Birth</p>
              </div>

              <div className="kg">
                <ul>
                  <li>
                    <b>{graphDetail?.atBirth?.value}</b>{" "}
                    <span>{graphDetail?.atBirth?.unit}</span>
                  </li>
                  <p className="date">
                    {formatToDDMMYYYY(graphDetail?.atBirth?.date)}
                  </p>
                </ul>
              </div>
            </div>

            <div className="lft_cards">
              <div className="at_birth">
                <p>Current</p>
              </div>

              <div className="kg">
                <ul>
                  <li>
                    <b>{graphDetail?.current?.value}</b>{" "}
                    <span>{graphDetail?.current?.unit}</span>
                  </li>
                  <p className="date">
                    {formatToDDMMYYYY(graphDetail?.current?.createdAt)}
                  </p>
                </ul>
              </div>
            </div>

            <div className="lft_cards">
              <div className="at_birth">
                <p>Change</p>
              </div>

              <div className="kg">
                <ul>
                  <li>
                    <b>
                      {Number(
                        graphDetail?.current?.value -
                          graphDetail?.atBirth?.value
                      ).toFixed(2)}
                    </b>{" "}
                    <span>{graphDetail?.atBirth?.unit}</span>
                  </li>
                  {/* <p className="date">24 Oct 2024</p> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="width_rgt_side">
            <div className="rgt_chart">
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="line"
                height={350}
              />
            </div>
          </div>
        </div>

        {/* Table Structre */}

        <div className="table_parent">
          <div class="frame">
            <div class="title">Frame</div>
            <div class="full-history">Full history</div>
            <div class="tabs">
              <div
                class={`tab ${duration === "DAY" ? "active" : ""}`}
                onClick={() => setDuration("DAY")}
              >
                Day
              </div>
              <div
                class={`tab ${duration === "WEEK" ? "active" : ""}`}
                onClick={() => setDuration("WEEK")}
              >
                Week
              </div>
              <div
                class={`tab ${duration === "MONTH" ? "active" : ""}`}
                onClick={() => setDuration("MONTH")}
              >
                Months
              </div>
            </div>

            {duration === "DAY" ? (
              <table class="history-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Week</th>
                    <th>
                      {type === "HEIGHT" ? "Height (Inches)" : "Weight(Kg)"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {measurement.map((measurementDetail, i) => (
                    <tr key={i}>
                      <td class="date">
                        {formatRelativeDate(
                          moment(measurementDetail?.createdAt).format(
                            "DD-MM-YYYY"
                          )
                        )}
                      </td>
                      <td class="week">
                        {measurementDetail?.week || ""}
                      </td>
                      <td class="weight">{measurementDetail?.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className=" col-sm-12">
                <div className="motorskilltracking_lft">
                  <Accordion className="outer_accordian">
                    {measurement.map((measurementDetail, i) => (
                      <Accordion.Item eventKey={i} key={i}>
                        <Accordion.Header>
                          {measurementDetail._id}{" "}
                          {firstWordCapital(duration.toLowerCase())}
                        </Accordion.Header>

                        <Accordion.Body>
                          <Accordion className="inner_accordian">
                            {measurementDetail?.measurements?.map((ele, j) => (
                              <Accordion.Item eventKey={j} key={j}>
                                <Accordion.Header>
                                  <div className="accordian_parent">
                                    <div className="accordian_child">
                                      <ul>
                                        <li>
                                          {formatRelativeDate(
                                            moment(ele?.createdAt).format(
                                              "DD-MM-YYYY"
                                            )
                                          )}
                                        </li>
                                        <li>{ele?.week}</li>
                                        <li>{ele?.value}</li>
                                      </ul>
                                    </div>
                                  </div>
                                </Accordion.Header>
                              </Accordion.Item>
                            ))}
                          </Accordion>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Measurement;
